export default __webpack_public_path__ + "static/media/next-arrow-icon.42af790b.svg";